import React, { useEffect, useState } from "react";
import { Modal } from "components/Modal/Modal";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "store";
import { closeModal } from "store/modals/slice";

import styles from "./ContentPreviewModal.module.scss";
import { getKycDocumentPreviewUrl } from "api/kycDocuments";
import PreviewSkeleton from "components/global/Skeleton/PreviewSkeleton/PreviewSkeleton";

export const ContentPreviewModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const documentId = searchParams.get("documentId");
  const userId = searchParams.get("userId");
  const [previewUrl, setPreviewUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userId || !documentId) return;

    const fetchPreview = async () => {
      try {
        setIsLoading(true);
        const result = await getKycDocumentPreviewUrl(
          Number(userId),
          Number(documentId),
        );
        setPreviewUrl(result.data.previewUrl);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPreview();
  }, [userId, documentId]);

  const handleCloseClick = () => {
    const returnUrl = searchParams.get("returnUrl");

    if (returnUrl) {
      navigate(`${location.pathname}${decodeURIComponent(returnUrl)}`);
    } else {
      navigate(location.pathname);
    }

    dispatch(closeModal());
  };

  return (
    <Modal
      onClose={handleCloseClick}
      className={styles["content-preview-modal"]}
    >
      <Modal.Header />

      <Modal.Content className={styles["content-preview-content"]}>
        {isLoading && <PreviewSkeleton />}

        {!isLoading && previewUrl && (
          <iframe
            src={previewUrl}
            title="Preview"
            className={styles["preview-frame"]}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};
